<template>
  <div class="shouye">
    <div class="body">
      <div class="nav_one">
        <div class="nav_i" style="width: 75.2%">
          <div class="nav_title">常用功能</div>
          <div class="nav_u">
            <div class="nav_item" v-for="item in useData" :key="item.id" @click="routerTo(item)">
              <img :src="item.icon" alt="" srcset="" />
              <span>{{ item.pri_name }}</span>
            </div>
          </div>
        </div>
        <div class="nav_i" style="width: 23.5%">
          <div class="nav_title">在线客服</div>
          <div class="nav_m">
            <div class="nav_c">
              <div>联系电话：</div>
              <div>4001130200</div>
            </div>
            <img src="../../assets/在线客服.png" alt="">
          </div>
        </div>
      </div>
      <div class="nav_one">
        <div class="nav_i" style="width: 100%">
          <div class="nav_title">数据统计</div>
          <div class="nav_link">
            <router-link tag="div" class="r_link" to="addressBook">
              <div class="link_l">
                <div>员工总数</div>
                <div>{{ tableData.user_total }}</div>
              </div>
              <div class="link_r">
                <img src="../../assets/数据.png" alt="">
              </div>
            </router-link>
            <router-link tag="div" class="r_link" to="saveContent">
              <div class="link_l">
                <div>会话总数</div>
                <div>{{ tableData.record_total }}</div>
              </div>
              <div class="link_r">
                <img src="../../assets/数据 (1).png" alt="">
              </div>
            </router-link>
            <router-link tag="div" class="r_link" to="adminManagement">
              <div class="link_l">
                <div>客户统计</div>
                <div>{{ tableData.contact_total }}</div>
              </div>
              <div class="link_r">
                <img src="../../assets/数据 (2).png" alt="">
              </div>
            </router-link>
            <router-link tag="div" class="r_link" to="complinance">
              <div class="link_l">
                <div>合规预警</div>
                <div>{{ tableData.trigger_total }}</div>
              </div>
              <div class="link_r">
                <img src="../../assets/数据 (3).png" alt="">
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <div class="body_waitao">
        <div class="big_l">
          <div class="nve">
            <div class="nve_l">
              <span>近七天员工会话量 & 合规预警次数</span>
              <span>了解您的客户资料如何随着时间的推移而增长</span>
            </div>
          </div>
          <div id="sevenChart"></div>
        </div>
        <div class="big_r">
          <div @click="$router.push('complinance')" class="today"
            :style="{ backgroundImage: backImg, backgroundSize: '49rem 32rem' }">
            <div class="nve_l">
              <span>今日合规预警触发（次数）</span>
            </div>
            <div class="big_r_t">
              <img src="../../assets/预警触发.png" alt="">
              <span>{{ todayTimes || 0 }}</span>
            </div>
          </div>
          <div @click="$router.push('complinance')" class="month"
            :style="{ backgroundImage: backImg, backgroundSize: '49rem 32rem' }">
            <div class="nve_l">
              <span>本月合规预警触发（次数）</span>
            </div>
            <div class="big_r_t">
              <img src="../../assets/预警触发.png" alt="">
              <span>{{ monthTimes || 0 }}</span>
            </div>
          </div>
        </div>
        <!-- <div class="body_statistics">
          <div class="body_name">
            <div @click="$router.push('saveContent')">
              <div class="nve">
                <h2>最近7天员工会话量</h2>
              </div>
              <div id="myChart" :style="{ width: '100%', height: '90%' }"></div>
            </div>
            <div @click="$router.push('complinance')">
              <div class="nve">
                <h2>最近7天合规预警次数</h2>
              </div>
              <div id="maing1" :style="{ width: '100%', height: '90%' }"></div>
            </div>
          </div>
          </div> -->
      </div>
      <div class="body_navdo">
        <div class="nav_title">消息公告</div>
        <div class="xiaoxi">
          <!-- <div class="search" @click="onMore">
            <el-input clearable placeholder="输入您想查找的关键词" v-model="q">
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </div> -->
          <div class="n-list">
            <template v-if="announcement.length">
              <div class="nvebd" v-for="(item, index) in announcement" :key="index">
                <div class="bbone" @click="announcements(item)">
                  <div class="cover" v-if="item.cover">
                    <el-image class="img" :src="item.cover" :preview-src-list="[item.cover]" fit="fill"></el-image>
                  </div>
                  <div class="n-content">
                    <div class="title">{{ item.title }}</div>
                    <!-- <div class="content" v-html="item.content"></div> -->
                    <div class="addtime">
                      <span>{{ item.addtime }}</span>
                      <span @click.stop="announcements(item)">查看详情 ></span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="more" @click="onMore">了解更多</div>
            </template>
            <div v-else class="noMore">暂无更多公告</div>
          </div>
          <!-- <div class="more" @click="onMore">了解更多</div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
let echarts = require("echarts/lib/echarts");
let ming = require("echarts/lib/echarts");
// 引入饼状图组件
require("echarts/lib/chart/pie");
// 引入提示框和title组件
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
export default {
  data() {
    return {
      title: {},
      tooken: "",
      tableData: [],
      a: 11,
      PriveCount: {},
      announcement: {},
      opss: [],
      now_mouth: "",
      now_mouths2: "",
      q: "",
      total_count: 0,
      labelWidth: 60,
      useData: [],
      complianceData: '',  //员工会话量
      wordNum: '',  //合规预警次数
      onceTime: '',  //近七天时间
      backImg: 'url(' + require('../../assets/今日预警背景图.png') + ')',
      todayTimes: '',
      monthTimes: ''
    };
  },
  mounted() {
    // 页面刷新就请求到数据渲染到页面中
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
    }
    this.aaabo();
    this.statistics();
    this.drawLine(); //柱状图员工会话量统计
    this.weizhi(); //柱状图员工合规预警次数统计
    this.money(); //饼图今日合规预警数据统计
    this.initData(); //饼图本欲合规预警数据统计
    this.updateChatrecord();
    this.getAccountPriveCount();
    this.getCommonUse();
  },
  filters: {
    formatDate: function (value) {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
    },
  },
  methods: {
    onMore() {
      this.$router.push({
        name: "news",
      });
    },
    announcements(item) {
      this.$router.push({
        name: "dataTotaladd",
        query: {
          id: item.id
        },
      });
    },
    getAccountPriveCount() {
      this.axios
        .post(
          "/crm/Mymine/getAccountPriveCount",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
          }),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.PriveCount = res.data.data;
        })
        .catch(function (err) { });
      this.axios
        .post(
          "/api/notice/lookNotice",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            scope: "3",
          }),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.announcement = res.data.data.data.slice(0, 3);
          // this.announcement = [
          //   {
          //     addtime: "2023-05-06 14:13:41"
          //     , content: "<p style=\"margin-top:0;margin-right:0;margin-bot"
          //     , cover: "http://work-1302521284.cos.ap-beijing.myqcloud.com/weijub/1683353396/1.png"
          //     , id: 257
          //     , knowledge_image: ""
          //     , notice_category_id: 7
          //     , scope: 3
          //     , scope_name: "企业CRM查看"
          //     , state: "已发布"
          //     , title: "SCRM类型有哪些？如何分类呢？"
          //     , updatetime: 0
          //   },
          //   {
          //     addtime: "2023-05-06 14:13:41"
          //     , content: "<p style=\"margin-top:0;margin-right:0;margin-bot"
          //     , cover: "http://work-1302521284.cos.ap-beijing.myqcloud.com/weijub/1683353396/1.png"
          //     , id: 257
          //     , knowledge_image: ""
          //     , notice_category_id: 7
          //     , scope: 3
          //     , scope_name: "企业CRM查看"
          //     , state: "已发布"
          //     , title: "SCRM类型有哪些？如何分类呢？"
          //     , updatetime: 0
          //   },
          //   {
          //     addtime: "2023-05-06 14:13:41"
          //     , content: "<p style=\"margin-top:0;margin-right:0;margin-bot"
          //     , cover: "http://work-1302521284.cos.ap-beijing.myqcloud.com/weijub/1683353396/1.png"
          //     , id: 257
          //     , knowledge_image: ""
          //     , notice_category_id: 7
          //     , scope: 3
          //     , scope_name: "企业CRM查看"
          //     , state: "已发布"
          //     , title: "SCRM类型有哪些？如何分类呢？"
          //     , updatetime: 0
          //   }
          // ]
        })
        .catch(function (err) { });
    },
    aaabo() {
      // 2
      this.axios
        .post(
          "/home/Wxwork/updateDepartment", ///home/Wxwork/updateDepartment
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
          }),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        )
        .then((res) => {
          //  3
          this.axios
            .post(
              "/home/Wxwork/updateDepartmentUser",
              qs.stringify({
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
                phone: this.tooken.phone,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              //4
              this.axios
                .post(
                  "/home/Wxwork/updateGroupchatList",
                  qs.stringify({
                    usertoken: this.tooken.usertoken,
                    account_id: this.tooken.account_id,
                    phone: this.tooken.phone,
                  }),
                  {
                    headers: {
                      "Content-Type": "application/x-www-form-urlencoded",
                    },
                  }
                )
                .then((res) => {
                  // 5
                  this.axios
                    .post(
                      "/crm/AssistantWelcomeNew/againUploadWelcome",
                      qs.stringify({
                        usertoken: this.tooken.usertoken,
                        account_id: this.tooken.account_id,
                        phone: this.tooken.phone,
                      }),
                      {
                        headers: {
                          "Content-Type": "application/x-www-form-urlencoded",
                        },
                      }
                    )
                    .then((res) => {
                      // 6
                      this.axios
                        .post(
                          "/home/Wxwork/updateExternalcontactList",
                          qs.stringify({
                            usertoken: this.tooken.usertoken,
                            account_id: this.tooken.account_id,
                            phone: this.tooken.phone,
                          }),
                          {
                            headers: {
                              "Content-Type":
                                "application/x-www-form-urlencoded",
                            },
                          }
                        )
                        .then((res) => { })
                        .catch(function (err) { });
                    })
                    .catch(function (err) { });
                })
                .catch(function (err) {
                  console.log(err)
                });
            })
            .catch(function (err) { });
        })
        .catch(function (err) { });
    },
    updateChatrecord() {
      this.axios
        .post(
          "/home/Wxwork/updateChatrecord",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
          }),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        )
        .then((res) => { })
        .catch(function (err) { });
    },
    // 员工统计。。。
    statistics() {
      this.axios
        .post(
          "/home/DataStatistics/dataTotal",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData = res.data.data;
        })
        .catch(function (err) { });
    },
    // 柱状图员工会话量统计
    drawLine() {
      this.axios
        .post(
          "/home/DataStatistics/dataSeven",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
          }),
          {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          const arr = [];
          res.data.data.forEach((item) => {
            arr.push(item.time);
          });
          const abb = [];
          res.data.data.forEach((item) => {
            abb.push(item.total);
          });
          let xAxisData = res.data.data.map((v) => v.time);
          let yAxisData2 = res.data.data.map((v) => v.total);
          this.complianceData = yAxisData2;
          let myChart = this.$echarts.init(document.getElementById("myChart"));
          let bgColor = "#fff";
          let color = [
            "#0090FF",
            "#36CE9E",
            "#FFC005",
            "#FF515A",
            "#8B5CFF",
            "#00CA69",
          ];
          const hexToRgba = (hex, opacity) => {
            let rgbaColor = "";
            let reg = /^#[\da-f]{6}$/i;
            if (reg.test(hex)) {
              rgbaColor = `rgba(${parseInt("0x" + hex.slice(1, 3))},${parseInt(
                "0x" + hex.slice(3, 5)
              )},${parseInt("0x" + hex.slice(5, 7))},${opacity})`;
            }
            return rgbaColor;
          };

          let option = {
            backgroundColor: "rgba(0,0,0,0)",
            color: "#0078E6",
            legend: {
              right: 10,
              top: 10,
              show: false,
            },
            tooltip: {
              trigger: "axis",
              formatter: function (params) {
                let html = "";
                params.forEach((v) => {
                  html += `<div style="color: #666;font-size: 1.4rem;line-height: 2.4rem">
                <span style="display:inline-block;margin-right:.5rem;border-radius:1.0rem;width:1.0rem;height:1.0rem;background-color:${color[v.componentIndex]
                    };"></span>
                ${v.name}<br/>会话量
                <span style="color:${color[v.componentIndex]
                    };font-weight:700;font-size: 1.8rem">${v.value}</span>
                分钟`;
                });
                return html;
              },
              extraCssText:
                "background: #fff; border-radius: 0;box-shadow: 0 0 .3rem rgba(0, 0, 0, 0.2);color: #333;",
              axisPointer: {
                type: "shadow",
                shadowStyle: {
                  color: "#ffffff",
                  shadowColor: "rgba(225,225,225,1)",
                  shadowBlur: 5,
                },
              },
            },
            grid: {
              top: 100,
              containLabel: true,
            },
            xAxis: [
              {
                type: "category",
                boundaryGap: false,
                axisLabel: {
                  formatter: "{value}",
                  textStyle: {
                    color: "#333",
                  },
                },
                axisLine: {
                  lineStyle: {
                    color: "#D9D9D9",
                  },
                },
                data: xAxisData,
              },
            ],
            yAxis: [
              {
                type: "value",
                name: "分钟",
                axisLabel: {
                  textStyle: {
                    color: "#666",
                  },
                },
                nameTextStyle: {
                  color: "#666",
                  fontSize: 12,
                  lineHeight: 40,
                },
                splitLine: {
                  lineStyle: {
                    type: "dashed",
                    color: "#E9E9E9",
                  },
                },
                axisLine: {
                  show: false,
                },
                axisTick: {
                  show: false,
                },
              },
            ],
            series: [
              {
                name: "会话量",
                type: "line",
                smooth: true,
                // showSymbol: false,
                symbolSize: 8,
                zlevel: 3,
                lineStyle: {
                  normal: {
                    color: "#0078E6",
                    shadowBlur: 3,
                    shadowColor: hexToRgba("#0078E6", 0.5),
                    shadowOffsetY: 8,
                  },
                },
                areaStyle: {
                  normal: {
                    color: new echarts.graphic.LinearGradient(
                      0,
                      0,
                      0,
                      1,
                      [
                        {
                          offset: 0,
                          color: hexToRgba("#0078E6", 0.3),
                        },
                        {
                          offset: 1,
                          color: hexToRgba("#0078E6", 0.1),
                        },
                      ],
                      false
                    ),
                    shadowColor: hexToRgba("#0078E6", 0.1),
                    shadowBlur: 10,
                  },
                },
                data: yAxisData2,
              },
            ],
          };
          myChart.setOption(option);
          // myChart.setOption({
          //   title: { text: "" },
          //   tooltip: {},
          //   xAxis: {
          //     data: arr,
          //   },
          //   yAxis: {},
          //   series: [
          //     {
          //       name: "近7天员工会话量",
          //       type: "bar",
          //       barWidth: 40,
          //       data: abb,
          //       itemStyle: { color: "#298EDB" },
          //     },
          //   ],
          // });
        })
        .catch(function (err) { });
    },
    // 柱状图员工合规预警次数统计
    weizhi() {
      this.axios
        .post(
          "/home/DataStatistics/sevenTriggerKeyword",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
          }),
          {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          const arr = [];
          res.data.data.forEach((item) => {
            arr.push(item.time);
          });
          const abb = [];
          res.data.data.forEach((item) => {
            abb.push(item.total);
          });
          let xAxisData = res.data.data.map((v) => v.time.slice(5));
          this.onceTime = xAxisData;
          let yAxisData2 = res.data.data.map((v) => v.total);
          this.wordNum = yAxisData2;
          this.seven();
          let myChart = this.$echarts.init(document.getElementById("maing1"));
          let bgColor = "#fff";
          let color = [
            "#0090FF",
            "#36CE9E",
            "#FFC005",
            "#FF515A",
            "#8B5CFF",
            "#00CA69",
          ];
          const hexToRgba = (hex, opacity) => {
            let rgbaColor = "";
            let reg = /^#[\da-f]{6}$/i;
            if (reg.test(hex)) {
              rgbaColor = `rgba(${parseInt("0x" + hex.slice(1, 3))},${parseInt(
                "0x" + hex.slice(3, 5)
              )},${parseInt("0x" + hex.slice(5, 7))},${opacity})`;
            }
            return rgbaColor;
          };

          let option = {
            backgroundColor: "rgba(0,0,0,0)",
            color: "#FF7341",
            legend: {
              right: 10,
              top: 10,
              show: false,
            },
            tooltip: {
              trigger: "axis",
              formatter: function (params) {
                let html = "";
                params.forEach((v) => {
                  html += `<div style="color: #666;font-size: 1.4rem;line-height: 2.4rem">
                <span style="display:inline-block;margin-right:.5rem;border-radius:1.0rem;width:1.0rem;height:1.0rem;background-color:#FF7341;"></span>
                ${v.name}<br/>预警次数
                <span style="color:#FF7341;font-weight:700;font-size: 1.8rem">${v.value}</span>
                次`;
                });
                return html;
              },
              extraCssText:
                "background: #fff; border-radius: 0;box-shadow: 0 0 .3rem rgba(0, 0, 0, 0.2);color: #333;",
              axisPointer: {
                type: "shadow",
                shadowStyle: {
                  color: "#ffffff",
                  shadowColor: "rgba(225,225,225,1)",
                  shadowBlur: 5,
                },
              },
            },
            grid: {
              top: 100,
              containLabel: true,
            },
            xAxis: [
              {
                type: "category",
                boundaryGap: false,
                axisLabel: {
                  formatter: "{value}",
                  textStyle: {
                    color: "#333",
                  },
                },
                axisLine: {
                  lineStyle: {
                    color: "#D9D9D9",
                  },
                },
                data: xAxisData,
              },
            ],
            yAxis: [
              {
                type: "value",
                name: "次",
                axisLabel: {
                  textStyle: {
                    color: "#666",
                  },
                },
                nameTextStyle: {
                  color: "#666",
                  fontSize: 12,
                  lineHeight: 40,
                },
                splitLine: {
                  lineStyle: {
                    type: "dashed",
                    color: "#E9E9E9",
                  },
                },
                axisLine: {
                  show: false,
                },
                axisTick: {
                  show: false,
                },
              },
            ],
            series: [
              {
                name: "预警次数",
                type: "line",
                smooth: true,
                // showSymbol: false,
                symbolSize: 8,
                zlevel: 3,
                lineStyle: {
                  normal: {
                    color: "#FF7341",
                    shadowBlur: 3,
                    shadowColor: hexToRgba("#FF7341", 0.5),
                    shadowOffsetY: 8,
                  },
                },
                areaStyle: {
                  normal: {
                    color: new echarts.graphic.LinearGradient(
                      0,
                      0,
                      0,
                      1,
                      [
                        {
                          offset: 0,
                          color: hexToRgba("#FF7341", 0.3),
                        },
                        {
                          offset: 1,
                          color: hexToRgba("#FF7341", 0.1),
                        },
                      ],
                      false
                    ),
                    shadowColor: hexToRgba("#FF7341", 0.1),
                    shadowBlur: 10,
                  },
                },
                data: yAxisData2,
              },
            ],
          };
          myChart.setOption(option);

          // myChart.setOption({
          //   title: { text: "" },
          //   tooltip: {},
          //   xAxis: {
          //     data: arr,
          //   },
          //   yAxis: {},
          //   series: [
          //     {
          //       name: "预警次数",
          //       type: "bar",
          //       barWidth: 40,
          //       data: abb,
          //       itemStyle: { color: "#298EDB" },
          //     },
          //   ],
          // });
        })
        .catch(function (err) { });
    },
    // 饼图今日合规预警数据统计
    money() {
      this.axios
        .post(
          "/home/DataStatistics/quarter",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            time: "today",
          }),
          {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.todayTimes = res.data.data.total_count;
          var a = res.data.data.list;
          this.opss = Object.values(a);

          // 获取键
          // 时间
          var a = res.data.data.now_mouth;
          this.now_mouth = a;

          // // 总数
          var c = res.data.data.total_count;
          this.total_count = res.data.data.total_count;
          var myChart = echarts.init(document.getElementById("mainng1"));
          // 绘制图表
          var abc = res.data.data.list;

          var color = [
            "#37A4DF",
            "#3751E6",
            "#FFC300",
            "#B39DDD",
            "#008DEC",
            "#114C90",
            "#00BFA5",
          ];
          const names = this.opss.map((i) => i.name);
          var legend = names;

          var seriesData = this.opss;

          var option = {
            backgroundColor: "#fff",
            color: color,
            grid: {
              top: "15%",
              left: 0,
              right: "1%",
              bottom: 5,
              containLabel: true,
            },
            legend: {
              orient: "vertical",
              top: "center",
              right: 50,
              textStyle: {
                align: "left",
                verticalAlign: "middle",
                rich: {
                  name: {
                    color: "rgba(0,0,0,0.6)",
                    fontSize: 12,
                  },
                  value: {
                    color: "rgba(0,0,0,0.6)",
                    fontSize: 12,
                  },
                  rate: {
                    color: "rgba(0,0,0,0.9)",
                    fontSize: 12,
                  },
                },
              },
              data: legend,
              formatter: (name) => {
                if (seriesData.length) {
                  const item = seriesData.filter(
                    (item) => item.name === name
                  )[0];
                  return `{name|${name}：} {rate| ${item.value}次}`;
                }
              },
            },
            series: [
              {
                name: "需求类型占比",
                type: "pie",
                center: ["35%", "50%"],
                radius: ["45%", "65%"],
                itemStyle: {
                  normal: {
                    borderWidth: 4,
                    borderColor: "#fff",
                  },
                },
                label: {
                  normal: {
                    show: false,
                    position: "center",
                    formatter: "{label|{b}}\n{value|{c}}",
                    rich: {
                      value: {
                        padding: 5,
                        align: "center",
                        verticalAlign: "middle",
                        fontSize: 32,
                      },
                      label: {
                        align: "center",
                        verticalAlign: "middle",
                        fontSize: 14,
                        color: "#19273C",
                      },
                    },
                  },
                  emphasis: {
                    show: true,
                    textStyle: {
                      fontSize: "12",
                    },
                  },
                },
                labelLine: {
                  show: false,
                  length: 0,
                  length2: 0,
                },
                data: seriesData,
                hoverOffset: 18,
              },
            ],
          };

          myChart.setOption(option);

          getDefaultSelected(myChart);

          function getDefaultSelected(myChart) {
            let index = 0;
            myChart.dispatchAction({
              type: "highlight",
              seriesIndex: 0,
              dataIndex: 0,
            });
            myChart.on("mouseover", (e) => {
              if (e.dataIndex !== index) {
                myChart.dispatchAction({
                  type: "downplay",
                  seriesIndex: 0,
                  dataIndex: index,
                });
              }
            });
            myChart.on("mouseout", (e) => {
              index = e.dataIndex;
              myChart.dispatchAction({
                type: "highlight",
                seriesIndex: 0,
                dataIndex: e.dataIndex,
              });
            });
          }
        })
        .catch(function (err) { });
      // 基于准备好的dom，初始化echarts实例
    },
    // 饼图本月触发统计
    initData() {
      this.axios
        .post(
          "/home/DataStatistics/quarter",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            time: "month",
          }),
          {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.monthTimes = res.data.data.total_count;
          var a = res.data.data.list;
          let op = Object.values(a);
          // 时间
          var a = res.data.data.now_mouths;
          this.now_mouths2 = a;
          // // 总数
          var c = res.data.data.total_count;
          var myChart = echarts.init(document.getElementById("main1"));
          // 绘制图表
          var _dataList = res.data.data.list;

          var seriesData = op;
          var color = [
            "#37A4DF",
            "#3751E6",
            "#FFC300",
            "#B39DDD",
            "#008DEC",
            "#114C90",
            "#00BFA5",
          ];
          const names = seriesData.map((i) => i.name);
          var legend = names;

          var option = {
            backgroundColor: "#fff",
            color: color,
            grid: {
              top: "15%",
              left: 0,
              right: "1%",
              bottom: 5,
              containLabel: true,
            },
            legend: {
              orient: "vertical",
              top: "center",
              right: 50,
              textStyle: {
                align: "left",
                verticalAlign: "middle",
                rich: {
                  name: {
                    color: "rgba(0,0,0,0.6)",
                    fontSize: 12,
                  },
                  value: {
                    color: "rgba(0,0,0,0.6)",
                    fontSize: 12,
                  },
                  rate: {
                    color: "rgba(0,0,0,0.9)",
                    fontSize: 12,
                  },
                },
              },
              data: legend,
              formatter: (name) => {
                if (seriesData.length) {
                  const item = seriesData.filter(
                    (item) => item.name === name
                  )[0];
                  return `{name|${name}：} {rate| ${item.value}次}`;
                }
              },
            },
            series: [
              {
                name: "需求类型占比",
                type: "pie",
                center: ["35%", "50%"],
                radius: ["45%", "65%"],
                itemStyle: {
                  normal: {
                    borderWidth: 4,
                    borderColor: "#fff",
                  },
                },
                label: {
                  normal: {
                    show: false,
                    position: "center",
                    formatter: "{label|{b}}\n{value|{c}}",
                    rich: {
                      value: {
                        padding: 5,
                        align: "center",
                        verticalAlign: "middle",
                        fontSize: 32,
                      },
                      label: {
                        align: "center",
                        verticalAlign: "middle",
                        fontSize: 14,
                        color: "#19273C",
                      },
                    },
                  },
                  emphasis: {
                    show: true,
                    textStyle: {
                      fontSize: "12",
                    },
                  },
                },
                labelLine: {
                  show: false,
                  length: 0,
                  length2: 0,
                },
                data: seriesData,
                hoverOffset: 18,
              },
            ],
          };

          myChart.setOption(option);

          getDefaultSelected(myChart);

          function getDefaultSelected(myChart) {
            let index = 0;
            myChart.dispatchAction({
              type: "highlight",
              seriesIndex: 0,
              dataIndex: 0,
            });
            myChart.on("mouseover", (e) => {
              if (e.dataIndex !== index) {
                myChart.dispatchAction({
                  type: "downplay",
                  seriesIndex: 0,
                  dataIndex: index,
                });
              }
            });
            myChart.on("mouseout", (e) => {
              index = e.dataIndex;
              myChart.dispatchAction({
                type: "highlight",
                seriesIndex: 0,
                dataIndex: e.dataIndex,
              });
            });
          }
        })
        .catch(function (err) { });
    },
    // 近七天 & 合规预警
    seven() {
      var data = {
        xData: this.onceTime,
        yData1: ["20", "6", "18"],
        yData2: ["15", "8", "16"],
        yName1: "员工会话量",
        yName2: "合规预警次数",
        yLabel: ""
      }
      let myChart = this.$echarts.init(document.getElementById("sevenChart"));

      window.addEventListener("resize", function (event) {
        myChart.resize();
      });

      let option = {
        backgroundColor: '#fff',
        legend: {
          show: true,
          top: '6%',
          right: '5%',
          itemWidth: 25,
          itemHeight: 14,
          textStyle: {
            color: '#666',
            fontSize: 14,
            padding: [0, 8, 0, 8]
          },
          data: [data.yName1, data.yName2]
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            label: {
              show: true,
              fontSize: 14,
              borderColor: '#fff',
              shadowOffsetY: 0,
            }
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          top: '20%',
          bottom: '20%',
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          data: data.xData,
          axisTick: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: "#666",
              fontSize: 14,
              fontWeight: 400
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#EBEFF3",
            },
          },
        }],
        yAxis: [{
          type: 'value',
          min: 0,
          name: data.yLabel,
          nameTextStyle: {
            color: "#666",
          },
          boundaryGap: false,
          axisTick: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: "#666",
              fontSize: 14,
              fontWeight: 400
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#F0F3F6",
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#F0F3F6",
            },
          },
        }],
        series: [{
          name: data.yName1,
          type: 'bar',
          data: this.complianceData,
          barWidth: 24,
          itemStyle: {
            color: '#EDF8F3',
          }
        },
        {
          name: data.yName2,
          type: 'bar',
          data: this.wordNum,
          barWidth: 24,
          barGap: "40%",
          barCategoryGap: "30%",
          itemStyle: {
            normal: {
              color: '#BCE9CC',
            }
          }
        },
        ],
      };
      myChart.setOption(option);
    },
    //获取常用功能数据
    getCommonUse() {
      this.axios.post('/home/role/RolePrivesCommon', qs.stringify({
        account_id: this.tooken.account_id,
        phone: this.tooken.phone,
      }))
        .then(res => {
          if (res.data.code == 1) {
            this.useData = res.data.data;
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    routerTo(item) {
      this.$router.push('/register/user/' + item.module_name)
    }
  },
};
</script>
<style scoped>
::v-deep .el-input__inner {
  background: #f6f6f6;
  color: #888;
  border: none;
}

::v-deep .el-button {
  padding: 2.2rem 5.7rem;
  color: #ccc;
  font-size: 1.8rem;
  font-weight: 400;
  border: .1rem solid #dbdbdb;
}

#sevenChart {
  width: 96rem;
  height: 53rem;
}

.body {
  width: 100%;
  height: 100%;
}

.nav_one {
  width: 100%;
  display: flex;
  justify-content: space-between;
  /* background-color: #fff; */
  /* padding: 2.0rem; */
  /* box-shadow: .0rem .0rem .8rem .0rem rgba(166, 173, 207, 0.2); */
  /* border-radius: .6rem; */
}

.nav_i {
  margin-bottom: 2rem;
}

.nav_title {
  font-size: 2.4rem;
  color: #333;
  line-height: 3.3rem;
  margin-bottom: 1.5rem;
}

.nav_u {
  display: flex;
  background: #fff;
  padding: 3rem 5.8rem;
  border-radius: .8rem;
}

.nav_m {
  display: flex;
  flex-direction: row-reverse;
  background: #fff;
  padding: 2.5rem 0 .4rem 2rem;
  border-radius: .8rem;
  position: relative;
}

.nav_m img {
  width: 19.1rem;
  height: 11.3rem;
}

.nav_c {
  position: absolute;
  top: 2rem;
  left: 2rem;
}

.nav_c div:first-child {
  font-size: 1.8rem;
  font-weight: 400;
  color: #666666;
  line-height: 2.5rem;
  margin-bottom: .8rem;
}

.nav_c div:last-child {
  font-size: 3.6rem;
  font-weight: bold;
  color: #49B372;
  line-height: 4.2rem;
}

.nav_item {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}

.nav_item img {
  width: 5rem;
  height: 5rem;
  margin-bottom: 1rem;
}

.nav_item span {
  font-size: 1.6rem;
  font-weight: 400;
  color: #333333;
  line-height: 2.2rem;
}

.nav_link {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.r_link {
  display: flex;
  padding: 2rem 2.5rem 3.2rem 2rem;
  background: #fff;
  border-radius: .8rem;
  margin-bottom: 2rem;
}

.link_l div:first-child {
  font-size: 1.8rem;
  font-weight: 400;
  color: #666666;
  line-height: 2.5rem;
  margin: 0 13.7rem 3.7rem 0;
}

.link_l div:last-child {
  font-size: 3.6rem;
  font-weight: 500;
  color: #333333;
  line-height: 5rem;
}

.link_r {
  padding: 6.9rem 0 .8rem;
}

.link_r img {
  width: 11.6rem;
  height: 7.1rem;
}

.langse {
  display: inline-block;
  width: .8rem;
  height: 2rem;
  background: #01bddd;
  border-radius: .4rem;
}

.langses {
  display: inline-block;
  width: .8rem;
  height: 3rem;
  background: #01bddd;
  border-radius: .4rem;
}

.nav {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.nav>div {
  width: 24.18%;
  height: 20rem;
  display: inline-block;
  padding: 2rem 3rem;
  /* box-shadow: .0rem .0rem 1.0rem .0rem rgba(113, 121, 135, 0.14); */
  /* background-color: rgba(255, 255, 255, 1); */
  border-radius: .5rem;
}

.body_waitao {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 2rem;
}

.body_statistics {
  width: 74.7%;
}

.big_l {
  height: 66rem;
  padding: 2.7rem 3rem 0 3rem;
  background: #fff;
  border-radius: .8rem;
}

.big_r {
  width: 32%;
}

.body_name {
  width: 100%;
  display: flex;
  margin-top: 4rem;
  justify-content: space-between;
}

.body_navdo {
  /* width: 24.19%; */
  margin-bottom: 2rem;
}

.navdo_nav {
  padding: 1.2rem;
  background: #ffffff;
  box-shadow: .0rem .0rem .8rem .0rem rgba(146, 155, 203, 0.2);
  border-radius: .6rem;
}

.navdo_navs {
  background: #ffffff;
  box-shadow: .0rem .5rem 3.0rem .0rem rgba(0, 0, 0, 0.05);
  border-radius: 1rem;
  height: 89.8rem;
  padding: 0 3rem;
}

.navdo_nav_title {
  width: 100%;
  padding: 2.72rem 0;
  border-bottom: .1rem solid #dcdcdc;
  display: flex;
  align-items: center;
}

.navdo_nav_title>h2 {
  font-size: 2.4rem;
  font-weight: 500;
  color: #19273c;
}

.list_boyd {
  width: 100%;
  height: 30rem;
}

.list_boyd>ul>li {
  font-size: 2.1rem;
  line-height: 5rem;
  margin-left: 2rem;
  color: #515151;
  font-weight: 400;
}

.body_name>div {
  position: relative;
  width: 49.3%;
  height: 44.3rem;
  display: inline-block;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: .0rem .5rem 3.0rem .0rem rgba(0, 0, 0, 0.05);
  border-radius: 1rem;
  overflow: hidden;
}

.nav>div>span {
  font-size: 2.2rem;
  display: flex;
  text-align: left;
  flex-direction: column;
}

.nav>div>span>div {
  display: inline-block;
  color: #fff;
  font-size: 1.8rem;
  font-weight: 400;
}

.nav>div>span>div:nth-child(1) {
  font-weight: 500;
  font-size: 4.8rem;
  line-height: 6.7rem;
}

.nav>div {
  background-size: 100% 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.nav>div>img {
  width: 5.6rem;
  height: 5.8rem;
}

.xiaoxi {
  width: 100%;
  cursor: pointer;
  background: #fff;
  padding: 3rem 3rem 0 3rem;
  border-radius: .8rem;
}

.n-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.xiaoxi>ul {
  padding: 2rem;
  border-bottom: .1rem solid #dcdcdc;
}

.xiaoxi>ul>li {
  font-size: 1.8rem;
}

.xiaoxi>ul>li>span:nth-child(1) {
  display: block;
}

.xiaoxi>ul>li>span:nth-child(2) {
  display: block;
  text-align: right;
}

.xiaoxi>ul:hover {
  color: #01bddd;
}

/* .nav>div:nth-child(1) {
  background-image: url("../../assets/staff.png");
}

.nav>div:nth-child(2) {
  background-image: url("../../assets/conversation.png");
}

.nav>div:nth-child(3) {
  background-image: url("../../assets/customer.png");
}

.nav>div:nth-child(4) {
  background-image: url("../../assets/warning.png");
} */

/* .nav > div > span > div:nth-child(2) {
  font-size: 2.4rem;
}
.nav > div > span > div:nth-child(1) {
  padding-left: .5rem;
} */
.nve {
  width: 100%;
  /* padding: .0rem 3.0rem; */
  position: relative;
}

.total {
  position: absolute;
  right: 4.5rem;
  top: 11.6rem;
  font-size: 1.2em;
  transform: scale(0.85);
  display: flex;
  align-items: center;
}

.total-l {
  text-align: left;
  display: flex;
  align-items: center;
}

.total-l-l {
  background: #d53a35;
  border-radius: .4rem;
  width: 3rem;
  height: 1.6rem;
  display: inline-flex;
  margin-right: .6rem;
}

.total-l-r {
  color: #7f7f7f;
}

.total-r {
  padding-left: 1rem;
  color: #19273c;
}

.nve_l span {
  display: block;
}

.nve_l span:nth-child(1) {
  font-size: 2.4rem;
  font-weight: 500;
  color: #333333;
  line-height: 3.3rem;
  margin-bottom: 4rem;
}

.nve_l span:nth-child(2) {
  font-size: 1.4rem;
  font-weight: 400;
  color: #666666;
  line-height: 2rem;
}

.today,
.month {
  height: 32rem;
  padding: 2rem 2rem 1.5rem 2rem;
  background: #fff;
  border-radius: .8rem;
}

.today {
  margin-bottom: 2rem;
}

.big_r_t img {
  width: 6rem;
  height: 6.4rem;
  margin-right: 8.1rem;
}

.big_r_t span {
  font-size: 7.2rem;
  font-weight: 500;
  color: #333333;
  line-height: 10rem;
}

/* .nve > div {
  width: 90%;
  height: .1rem;
  background: rgba(229, 229, 229, 1);
  margin: 0 auto;
} */
.now_mouth {
  position: absolute;
  right: 3rem;
  margin-top: .6rem;
  font-weight: 400;
  color: #ccc;
  font-size: 1.8rem;
}

.search {
  margin: 1.6rem 0 3rem;
}

.nvebd {
  width: 40.82%;
  margin-bottom: 3rem;
}

.bbone {
  display: flex;
}

.bbone .cover .img {
  width: 18rem;
  height: 10rem;
  margin-right: 2rem;
}

.bbone .n-content {
  width: 67%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.bbone .title {
  font-size: 1.8rem;
  font-weight: 500;
  color: #333333;
  line-height: 2.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.bbone .content {
  margin-top: .6rem;
  font-weight: 400;
  color: #888888;
  line-height: 2.4rem;
  width: 30rem;
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.bbone .addtime {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.bbone .addtime span:nth-child(1) {
  font-size: 1.4rem;
  font-weight: 400;
  color: #FFAB2B;
  line-height: 2rem;
}

.bbone .addtime span:nth-child(2) {
  font-size: 1.2rem;
  font-weight: 400;
  color: #49B372;
  line-height: 1.7rem;
  cursor: pointer;
}

.noMore {
  width: 100%;
  text-align: center;
  font-size: 1.6rem;
  font-weight: 400;
  color: #999999;
  line-height: 2.2rem;
  margin-bottom: 3rem;
}

.more {
  width: 8rem;
  height: 4rem;
  text-align: center;
  line-height: 4rem;
  background: #49B372;
  border-radius: .8rem;
  font-size: 1.4rem;
  font-weight: 400;
  color: #FFFFFF;
  position: relative;
  top: 6rem;
}
</style>